import { render } from "./IndexSubscriptionsPage.vue?vue&type=template&id=56cc179a&scoped=true"
import script from "./IndexSubscriptionsPage.vue?vue&type=script&lang=js"
export * from "./IndexSubscriptionsPage.vue?vue&type=script&lang=js"

import "./IndexSubscriptionsPage.vue?vue&type=style&index=0&id=56cc179a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56cc179a"]])

export default __exports__